import {assert} from 'assert-ts';
import type {GetTokens, Media} from './types';
import type {Schemas} from './dto.generated';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpGet, httpPost} from './http/ebba';
import {mapMediaForEans} from './mappers/mapMediaDto';

export const getMediaByEans = (
  eans: string[],
  getTokens: GetTokens,
  mock?: boolean,
): Promise<Media[]> => {
  return exceptionToPromiseReject(() =>
    httpPost<Schemas.MediaForEansDto, string[]>({
      subdir: 'media/ean',
      body: eans,
      getTokens,
      mock,
    }).then(mapMediaForEans),
  );
};

export const getMediaUrl = (
  mediaId: string,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<string> => {
  return exceptionToPromiseReject(() =>
    httpGet<Schemas.DownloadInfoDto>({
      subdir: 'media/{mediaId}',
      subdirParams: {mediaId},
      getTokens,
      mock,
    }).then(dto => assert(dto.uri, 'getMediaUrl: uri expected')),
  );
};

/**
 * Soft delete media.
 */
export const deleteMedia = (
  ean: string,
  media: Pick<Media, 'subType' | 'fileNr'>,
  getTokens: GetTokens,
  mock?: boolean,
): Promise<void> => {
  return exceptionToPromiseReject(() =>
    httpPost({
      subdir: 'media/soft-delete/{ean}',
      subdirParams: {ean},
      queryParams: {
        fileType: media.subType,
        fileNumber: media.fileNr,
      },
      getTokens,
      mock,
    }),
  );
};
